<template>
  <div class="navbar-layout">
    <div class="user-info">
      <img class="user-info__avatar" :src="doctor.imageProfileUrl" />
      <div>
        <h4 class="button-text">
          {{ (doctor.treatment == 1 ? 'Dra. ' : 'Dr. ') + getFullName }}
        </h4>
        <h6 class="details-text">{{ doctor.lumineCredential }}</h6>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import Vue from 'vue'
import { mapGetters, mapState } from 'vuex'
export default Vue.extend({
  name: 'NavBar',

  computed: {
    ...mapState('doctor', ['doctor']),
    ...mapGetters('doctor', ['getFullName'])
  }
})
</script>

<style lang="sass" scoped>
@import @/assets/sass/style

.navbar-layout
    background: $white
    width: 100%
    height: 80px
    min-height: 80px
    display: flex
    justify-content: flex-end
    align-items: center
    padding: 4px 24px
    border-bottom: 1px solid $strokes

    .user-info
        display: flex

        &__avatar
            object-fit: contain
            width: 40px
            padding-right: 8px
</style>
